import { Menu } from "lucide-react";
import { useState, type ReactNode } from "react";
import DesktopMenu from "./DesktopMenu";
import { Button } from "../../DesignSystem";
import Tooltip from "../../DesignSystem/Tooltip";

type Props = {
    customView?: ReactNode;
    addClasses?: string;
    showFullMenu?: boolean;
};

// TODO: We should probably rethink the Desktop + Mobile menu at some point and have this just accept a title and icon potentially, but for now I'm adding the ability to insert a custom view to match the Vendor Discovery mobile design

export default function SlideoutMenu({ customView, addClasses, showFullMenu }: Props) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={addClasses}>
            {customView ? (
                <div onClick={() => setIsOpen(!isOpen)}>{customView}</div>
            ) : (
                <Tooltip text="Menu" align="bottom" className="hidden md:block">
                    <Button
                        color="clear"
                        icon={<Menu className="h-4 w-4 stroke-stone-600" />}
                        className="px-2 py-2 hover:bg-stone-200 active:bg-stone-300"
                        onClick={() => setIsOpen(!isOpen)}
                    />
                </Tooltip>
            )}

            <div className={`${isOpen ? "w-[244px]" : "w-0 overflow-scroll"} fixed top-0 left-0 z-40 transition-[width] duration-300`}>
                <DesktopMenu showFullMenu={showFullMenu} showCollapseOption={false} className="relative z-50 block! shadow" />
                {isOpen ? <div className="fixed top-0 right-0 bottom-0 left-0 z-10 bg-white/60" onClick={() => setIsOpen(!isOpen)} /> : null}
            </div>
        </div>
    );
}
